<template>
  <AppSidebar
    :visible="showNavigationSidebar"
    :dismiss-on-body-click="false"
    :has-close-button="false"
    class="insights-navigation"
    :class="`${currentDashboard}-dashboard`"
    :sidebar-style="sidebarStyle"
    @show="toggleNavigationSidebar"
    @close="toggleNavigationSidebar"
  >
    <InsightsNavigationLists />
  </AppSidebar>
</template>

<script>
import AppSidebar from '~/components/AppSidebar.vue';
import InsightsNavigationLists from '~/components/insights/InsightsNavigationLists.vue';
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash-es';

// Gap between the sticky header's bottom edge and the sidebar's own content (e.g. "Teams").
const CONTENT_TOP_GAP_PX = 25;

export default {
  name: 'InsightsNavigation',
  components: {
    AppSidebar,
    InsightsNavigationLists,
  },
  data() {
    return {
      sidebarStyle: '',
    };
  },
  computed: {
    ...mapGetters(['showNavigationSidebar', 'currentDashboard']),
  },
  mounted() {
    this.sticky = document.getElementById('insights-sticky-header');
    // Computed synchronously (in addition to the resize observer below) so the sidebar content has the
    // correct offset on its very first paint, instead of a guessed fallback that then jumps.
    this.updateContentTopPadding();
    this.debouncedUpdateContentTopPadding = debounce(this.updateContentTopPadding);
    this.setupResizeObserver();
  },
  beforeDestroy() {
    this.stopResizeObserver();
  },
  methods: {
    ...mapActions(['toggleNavigationSidebar']),
    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(this.debouncedUpdateContentTopPadding);
      this.resizeObserver.observe(this.sticky);
    },
    stopResizeObserver() {
      this.resizeObserver.unobserve(this.sticky);
    },
    updateContentTopPadding() {
      if (!this.sticky) {
        return;
      }
      // The sidebar box itself is pinned at $topbar-height (see _insights.scss) and is always fully
      // covered by the topbar + sticky header above it, so its top edge never gets revealed, even on
      // fast/bouncy scroll. Only the content's padding needs to track the header's actual height, so
      // content like "Teams" clears it instead of hiding underneath.
      const contentTopPadding = Math.round(this.sticky.getBoundingClientRect().height) + CONTENT_TOP_GAP_PX;
      const sidebarStyle = `--insights-sidebar-content-top-padding: ${contentTopPadding}px`;

      if (this.sidebarStyle !== sidebarStyle) {
        this.sidebarStyle = sidebarStyle;
      }
    },
  },
};
</script>
